import { combineReducers } from "@reduxjs/toolkit";

import LayoutReducer from "./layouts/reducer";
import UserReducer from "./user/reducer";
import CartReducer from "./cart/reducer";

const rootReducer = combineReducers({
    layout: LayoutReducer,
    user: UserReducer,
    cart: CartReducer,
});

export default rootReducer;